import QAQuestionItem from "./QAQuestionItem.component.jsx";

export default QAQuestionItem;
